import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import Geo from 'drip/geo';
import { SaleLabelList, LazyImage } from '@/components/common';
import { parseDetailUrl } from "@/utils";
export default {
  props: {
    projectList: {
      type: Array,
      value: []
    },
    celebrityName: {
      type: String,
      value: ''
    },
    celebrityId: {
      type: Number,
      value: 0
    }
  },
  components: {
    SaleLabelList: SaleLabelList,
    LazyImage: LazyImage
  },
  mounted: function mounted() {},
  methods: {
    to: function to(e, project) {
      var params = this.bidParams(project);
      try {
        var target = e.currentTarget;
        var performanceId = target.dataset.performanceid;
        var _target$dataset$jumpd = target.dataset.jumpdetailurl,
          jumpdetailurl = _target$dataset$jumpd === void 0 ? "" : _target$dataset$jumpd;
        window.seedAction(params);
        if (jumpdetailurl) {
          this.goWithWx({
            h5Url: parseDetailUrl(jumpdetailurl),
            wxPath: "/pages/show/detail/index?id=".concat(performanceId),
            douyinPath: jumpdetailurl
          });
        } else {
          this.goWithWx({
            h5Url: "/detail/".concat(performanceId),
            wxPath: "/pages/show/detail/index?id=".concat(performanceId),
            douyinPath: "/pages/show/detail/index?id=".concat(performanceId)
          });
        }
      } catch (e) {
        console.log('clickStatus error', e);
      }
    },
    bidParams: function bidParams(project) {
      var cityId = Drip.constant.cityId;
      var gcityId = (Geo.getLocCitySync() || {}).cityId || cityId;
      var params = {
        evt: 'click',
        bid: 'b_movie_j94lvp36_mc',
        celebrity_id: this.celebrityId,
        performance_id: (project || {}).performanceId,
        performance_state: (project || {}).ticketStatus,
        city_id: cityId,
        gcity_id: gcityId,
        needTag: true
      };
      return params;
    },
    tipsStyleMap: function tipsStyleMap(_ref) {
      var saleLabel = _ref.saleLabel,
        seatMode = _ref.seatMode;
      var textList = {
        1: {
          label: '即将开售'
        },
        11: {
          label: '即将开抢'
        },
        3: {
          label: '选座购票',
          style: {
            'background-color': '#FFF5F4',
            color: '#F03D37',
            'background-image': 'none'
          }
        }
      };
      if (saleLabel === 1 || saleLabel === 11) {
        return textList[saleLabel];
      } else if (saleLabel === 3 && seatMode === 1) {
        return textList[3];
      }
      return {};
    },
    getMvParams: function getMvParams(viewBid, item) {
      var performanceId = item.performanceId;
      var params = {
        evt: 'view',
        viewBid: viewBid,
        custom: {
          custom: {
            celebrity_id: this.celebrityId,
            performance_id: performanceId
          }
        }
      };
      return JSON.stringify(params);
    }
  }
};